// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoHero_videoContainer__Fn3--","videoPlayer":"VideoHero_videoPlayer__nsLQr","content":"VideoHero_content__FFn1q"};